import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const TransactionListByCustomer = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  const paramObject = useParams();
  const apicall = () => {
    axios
      .get(
        `${config.reportsBaseUrl}/reports/transactionlistbycustomer?startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, data) => {
      const reportTotal = Number(data.Amountline);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const columnDefs = [
    { field: "CustomerName", enableRowGroup: true },
    { field: "TransactionDate", enableRowGroup: true },
    { field: "TransactionType", enableRowGroup: true },
    { field: "Transactionnumber", enableRowGroup: true },
    { field: "Memo", enableRowGroup: true },
    { field: "Account", enableRowGroup: true },
    {
      field: "Amount",
      width: 200,
      enableValue: true,
      suppressMenu: true,
      filter: "agNumberColumnFilter",
      aggFunc: "sum",
      valueGetter: function (params) {
        // Parse the string OpenBalance and return as an integer
        const amount = parseInt(params.data.Amount, 10);
        return isNaN(amount) ? 0 : amount;
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    resizable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const onGridReady = useCallback((params) => {
    setLoading(true);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/transactionlistbycustomer?startdate=${""}&enddate=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `TransactionListByCustomer_.xlsx`);
  };

  const handleDownloadPDF = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(responseData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Customer Name</th>' +
        '<th style="padding: 7px;">Transaction Date</th>' +
        '<th style="padding: 7px; ">Transaction Type</th>' +
        '<th style="padding: 7px;">Transaction Number</th>' +
        '<th style="padding: 7px;">Memo</th>' +
        '<th style="padding: 7px; ">Account</th>' +
        '<th style="padding: 7px; text-align: right;">Amount</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].Date).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].TransactionDate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Transactionnumber +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Account +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Transaction-list.pdf");
        setLoading(false);
      },
    });
  };

  const handlePrintPDF = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(responseData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Customer Name</th>' +
        '<th style="padding: 7px;">Transaction Date</th>' +
        '<th style="padding: 7px; ">Transaction Type</th>' +
        '<th style="padding: 7px;">Transaction Number</th>' +
        '<th style="padding: 7px;">Memo</th>' +
        '<th style="padding: 7px; ">Account</th>' +
        '<th style="padding: 7px; text-align: right;">Amount</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].Date).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].TransactionDate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Transactionnumber +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Account +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        setLoading(false);
        pdf.output("dataurlnewwindow");
      },
    });
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Transaction List By Customer</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Transaction Lis By Customer
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3 ">
              <div className="form-group row">
                <label className="col-form-label col-md-5 form-label">
                  Report period
                </label>
                <div className="col-md-7">
                  <Select
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-primary pull-right "
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>SonarPos</h2>
                  <h6 className="fw-bold">Transaction List By Customer</h6>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <h6>
                      Date: {startdate} - {enddate}
                    </h6>
                  </div>
                </div>
              </div>
              <hr />

              <div className="button">
                <button
                  onClick={onBtExport}
                  className="btn btn-sm btn-outline-dark  m-1"
                  // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-excel mr-2"></i>
                  Export to Excel
                </button>
                <button
                  onClick={handleDownloadPDF}
                  className="btn btn-sm btn-outline-dark  m-1"
                  // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-export mr-2"></i>
                  Export to Pdf
                </button>
                <button
                  className="btn btn-sm btn-outline-dark  m-1"
                  onClick={handlePrintPDF}
                >
                  {" "}
                  <i class="fas fa-print mr-2"></i>Print
                </button>
              </div>

              {/* { headerName: "CustomerName", minWidth: 130 } */}
              <div className="table-responsive">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={data}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                    rowGroupPanelShow={"always"}
                  ></AgGridReact>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionListByCustomer;
